//フェードダウンアニメーション（
document.addEventListener("DOMContentLoaded", function () {
    function fadeCollection() {
        var collectionElements = document.querySelectorAll('.fadeIndex');
        var windowHeight = window.innerHeight;

        collectionElements.forEach(function (element) {
            var elementPosition = element.getBoundingClientRect().top;
            var scrollPosition = window.pageYOffset;

            if (scrollPosition >= elementPosition - windowHeight) {
                element.classList.add('fadeDownIndex');
            } else {
                element.classList.remove('fadeDownIndex');
            }
        });
    }
 
    window.addEventListener('scroll', function () {
        fadeCollection();
    });
});